import * as Obj from '@pkg/utils/objects';

/**
 * @param {object} variables
 * @param {object} [variables.input]
 */
export default function onDispatch(variables) {
  return Obj.omitDerived(variables);
}
